import { inject, Injectable } from '@angular/core';
import {
  CommentResult,
  CommentsResult,
  DeleteCommentDocument,
  DeleteCommentMutationVariables,
  DeleteCommentResult,
  GetCommentsDocument,
  GetCommentsQueryVariables,
  LikeCommentDocument,
  LikeCommentMutationVariables,
  LikeCommentResult,
  SubmitCommentDocument,
  SubmitCommentMutationVariables,
} from '@shared/graphql/api.generated';
import { GraphqlClients, GraphqlService } from '@shared/graphql/graphql.service';

@Injectable()
export class CommentService {
  private readonly graphqlService = inject(GraphqlService);

  getComments(programID: string, episodeID?: string, page = 1) {
    return this.graphqlService.makeQuery<CommentsResult, GetCommentsQueryVariables>(
      GraphqlClients.api,
      GetCommentsDocument,
      {
        programID,
        episodeID,
        page,
      },
    );
  }

  submitComment(programID: string, comment: string, episodeID?: string) {
    return this.graphqlService.makeMutation<CommentResult, SubmitCommentMutationVariables>(
      GraphqlClients.api,
      SubmitCommentDocument,
      {
        programID,
        episodeID,
        comment,
      },
    );
  }

  likeComment(commentID: string, programID: string) {
    return this.graphqlService.makeMutation<LikeCommentResult, LikeCommentMutationVariables>(
      GraphqlClients.api,
      LikeCommentDocument,
      {
        commentID,
        programID,
      },
    );
  }

  deleteComment(commentID: string, programID: string) {
    return this.graphqlService.makeMutation<DeleteCommentResult, DeleteCommentMutationVariables>(
      GraphqlClients.api,
      DeleteCommentDocument,
      {
        commentID,
        programID,
      },
    );
  }
}
